import React, { useState, useEffect } from "react";
import "./Home.css";
import ReactCardFlip from "react-card-flip";
import { useInView } from "react-intersection-observer";
import { AiOutlinePlus, AiOutlineClose } from "react-icons/ai";
import { Link, useLocation } from "react-router-dom";
import Contect from "../Contect/Contect";
import { IoAddCircleSharp } from "react-icons/io5";
import WorkA from "../Work/WorkA/WorkA";
import WorkB from "../Work/WorkB/WorkB";
import WorkC from "../Work/WorkC/WorkC";
import WorkD from "../Work/WorkD/WorkD";
import TiltPhaseSix from "../../Components/TiltPhoseSix/TiltPhaseSix";
function Home({ lang, theme }) {
  const location = useLocation();

  // this function is used to send page on top
  useEffect(() => {
    if (location.hash === "") {
      document.getElementById("element").scrollIntoView({ behavior: "smooth" });
    }
  }, [location.hash]);
  // thse useRef are used for scroll effect.
  const [ref, inView] = useInView({ threshold: 0.5 });
  const [ref2, inView2] = useInView({ threshold: 0.5 });
  // this array is used to open and close question tab.
  const [isFliped, setIsfliped] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  // these varible are used to opena and close model panel.
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [modalA, setModalA] = useState(false);
  const toggleA = () => setModalA(!modalA);
  const [modalB, setModalB] = useState(false);
  const toggleB = () => setModalB(!modalB);
  const [modalC, setModalC] = useState(false);
  const toggleC = () => setModalC(!modalC);
  const [modalD, setModalD] = useState(false);
  const toggleD = () => setModalD(!modalD);
  const HanldeCheck = (index) => {
    setIsfliped((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : item))
    );
  };
  // used for work image effect.
  const options = {
    max: 10,
    perspective: 1000,
    scale: 0.7,
  };
  return (
    <>
      <Contect lang={lang} theme={theme} modal={modal} toggle={toggle} />
      <WorkA lang={lang} theme={theme} modal={modalA} toggle={toggleA} />
      <WorkB lang={lang} theme={theme} modal={modalB} toggle={toggleB} />
      <WorkC lang={lang} theme={theme} modal={modalC} toggle={toggleC} />
      <WorkD lang={lang} theme={theme} modal={modalD} toggle={toggleD} />
      <div className={`${theme ? "light" : "dark"}`} id="element">
        <div className={`container-fluid home`}>
          <div className="row home-content d-flex justify-content-center">
            <div className="col-lg-12 pb-3 pt-3 d-flex justify-content-center">
              {/* Removing / for github only  */}
              <div class="row container--hero d-flex  align-items-center justify-content-center">
                <div class="hero-img-wrap">
                  <div class="hero-img-container">
                    <img
                      src="mg-full/AboutMe(1).png"
                      alt="Portraitfoto von Moritz Petersen, dem Webflow Experten"
                      class="hero-img"
                    />
                  </div>
                  <div id="hero-img-shadow-1" class="hero-img-shadow-wrap">
                    <div class="hero-img-shadow"></div>
                  </div>
                  <div
                    id="hero-img-shadow-2"
                    class="hero-img-shadow-wrap hero-img-shadow-wrap--intro"
                  >
                    <div class="hero-img-shadow"></div>
                  </div>
                </div>
                <div class="hero__header">
                  <h2 class="hero-eyebrow">Miguel González</h2>
                  <div class="hero-heading-ui-wrap">
                    <div class="hero-heading-ui">
                      <div class="hero-heading-ui-tab">
                        <div class="hero-heading-ui-tab-h1">H1</div>
                        <div>hero heading</div>
                      </div>
                    </div>
                    <h1 class="hero-heading">{lang?"Desarrollador Full Stack Jr":'A Jr. Full Stack Developer'}.</h1>
                  </div>
                  <div
              className="col-lg-12 d-flex justify-content-center py-4"
              onClick={() => setModal(!modal)}
            >
              <h4 className="bold blue__color text-center">
                <span>
                  {lang
                    ? "Hagamos cosas que marquen la diferencia >"
                    : "Let's do thing that make a difference >"}{" "}
                </span>
              </h4>
            </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid section__2 d-none d-lg-block">
          <div className="row d-flex justify-content-center">
            <div className="col-10 text-center">
              {lang ? (
                <h1>¿Tiene un proyecto intersante en el que necesita ayuda?</h1>
              ) : (
                <h1>Have an exciting project where you need some help?</h1>
              )}
            </div>
          </div>
        </div>
        <div className="container-fluid section__3" id="aboutus">
          <div className="row section__3__content d-flex justify-content-center">
            <div className="col-lg-9">
              <h4>
                <span className="about-text">
                  {lang ? "Sobre Mí" : "About Me"}
                </span>
              </h4>
            </div>
            <div className="col-lg-9 ">
              {lang ? (
                <h1>Desarrollador creativo en remoto.</h1>
              ) : (
                <h1>Remote creative developer.</h1>
              )}
            </div>
            <div className="col-lg-12 ">
              <div className="row section__3__about d-flex justify-content-between">
                <div className="col-lg-6 ">
                  {lang ? (
                    <h3>Desarrollador Full Stack.</h3>
                  ) : (
                    <h3>A Full Stack Developer.</h3>
                  )}
                  <br />
                  {lang ? (
                    <p>
                      Hola, soy Miguel, un desarrollador web creativo que
                      trabaja en remoto desde la soleada isla de Tenerife
                      (España). Soy un recién llegado al mundo de crear
                      productos y experiencias web atractivas.
                      <br />
                      Busco oportunidades para colaborar con empresas / agencias
                      / autónomos / particulares, pero no sólo para trabajar con
                      ellos. Quiero aportar mis conocimientos y experiencia en
                      desarrollo y poder trabajar juntos en la solución de
                      problemas reales de una manera que aproveche nuestros
                      respectivos conocimientos y experiencias.
                      <br />
                      Si esto le suena bien, entonces hablemos de cómo podemos
                      trabajar juntos.
                      <br />
                    </p>
                  ) : (
                    <p>
                      Hi, I'm Miguel, a creative web developer working remotely
                      from the sunny island of Tenerife (Spain). I'm a newcomer
                      to the world of creating engaging web products and
                      experiences.
                      <br />
                      I'm looking for opportunities to collaborate with
                      companies / agencies / freelancers / individuals, but not
                      only to work with them. I want to bring my knowledge and
                      experience in development and be able to work together on
                      solving real problems in a way that leverages our
                      respective knowledge and experience.
                      <br />
                      If this sounds good to you, then let's talk about how we
                      can work together.
                      <br />
                    </p>
                  )}
                  <h3>
                    {" "}
                    <span
                      className="blue__color"
                      onClick={() => setModal(!modal)}
                    >
                      {lang
                        ? "Envíame un mensaje y charlemos >"
                        : "Send me a message and let's chat >"}
                    </span>
                  </h3>
                </div>
                <div className="col-lg-5 d-flex  justify-content-center align-items-center pb-5  ">
                  <div className="image  p-relative">
                    <img
                      className="section__3__about__img  "
                      src="/mg-full/AboutMe(1).png"
                      alt="me"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section__4 container-fluid" id="myskill">
          <div className="row section__4__content  d-flex justify-content-center">
            <div className="col-lg-9">
              <h4>
                <span className="about-text">
                  {lang ? "Mis Habilidades" : "My Skills"}
                </span>
              </h4>
            </div>
            <div className="col-lg-9">
              {lang ? (
                <h1>
                  Siempre <br /> Aprendiendo
                </h1>
              ) : (
                <h1>
                  Always <br /> learning
                </h1>
              )}
            </div>
            <div className="col-lg-12  section__4__client__margin">
              <div className="row">
                <div className="col-lg-6 section__4__client ">
                  <h3>
                    {lang
                      ? " Desarrollador Full Stack para construir tu diseño > código >web."
                      : "Full Stack developer to transform your design > code > site."}
                  </h3>
                  <p className="section__4__client__p">
                    {" "}
                    Creo sitios web responsive rápidos, fáciles de usar y
                    construidos con las mejores prácticas. Mi principal
                    experiencia es el desarrollo FrontEnd, HTML, CSS, JS,
                    MongoDB, Express, React & Nodejs (MERN), construyendo
                    aplicaciones web pequeñas y medianas, características,
                    animaciones y codificando diseños interactivos. Mi
                    conocimiento como desarrollador Full Stack también me
                    permite construir un BackEnd adecuado a sus necesidades.
                  </p>
                </div>
                <div className="col-lg-6 ">
                  <div className="row row-cols-2 h-100">
                    <div className="mb-lg-4 my-4 mt-lg-0 ">
                      <div className="section__4__client_s custom_pad text-center w-100 h-100  d-flex justify-content-center align-items-center flex-column">
                        <h1 className="client m-0">
                          4<sup>+</sup>
                        </h1>
                        <h6 className="section__4__client__p">
                          Clientes Felices
                        </h6>
                      </div>
                    </div>
                    <div className="mb-lg-4 my-4  mt-lg-0 ">
                      <div className="section__4__client_s custom_pad d-flex justify-content-center align-items-center flex-column w-100 h-100">
                        <h1 className="exprerience m-0">
                          -1<sub>Año</sub>
                        </h1>
                        <h6 className="section__4__client__p">Experiencia</h6>
                      </div>
                    </div>
                    <div className=" ">
                      <div className="section__4__client_s custom_pad text-center w-100 h-100  d-flex justify-content-center align-items-center flex-column">
                        <h1 className="prototype m-0">
                          4<sup>+</sup>
                        </h1>
                        <h6 className="section__4__client__p">Proyectos Web</h6>
                      </div>
                    </div>
                    <div className="">
                      <div className="section__4__client_s custom_pad text-center w-100 h-100  d-flex justify-content-center align-items-center flex-column">
                        <h1 className="profession m-0">
                          100<sub>%</sub>
                        </h1>
                        <h6 className="section__4__client__p">Profesional</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12  section__4__client__margin section__5">
              <div className="row d-flex justify-content-md-between">
                <div className="col-lg-5 d-flex  justify-content-center flex-column pe-lg-5">
                  {lang ? (
                    <h3>
                      Entusiasta de la
                      <br /> Animación.
                    </h3>
                  ) : (
                    <h3>
                      Animation <br />
                      Enthusiast.
                    </h3>
                  )}
                  {lang ? (
                    <p>
                      Tanto si se trata de sutiles iconos animados que mejoran
                      la UI o animaciones para productos digitales más
                      complejos. Yo puedo crearlos y añadirlos a su proyecto.
                    </p>
                  ) : (
                    <p>
                      Whether it's subtle animated icons that improve UI or
                      animations for more complex digital products. I can build
                      them and add them to your project.
                    </p>
                  )}
                </div>
                <div className="col-lg-6 tv position-relative p-0 m-0 d-flex justify-content-center mt-3 mt-md-0">
                  <img
                    src="/mg-full/Moniter.png"
                    alt="mointer"
                    className="tv-img"
                  />
                  <video
                    autoPlay={true}
                    loop={true}
                    controls={false}
                    playsInline
                    muted
                    className="position-absolute video "
                  >
                    <source src="/mg-full/3dAnimation.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
            <div className="col-lg-12  section__4__client__margin section__6">
              <div className="row  ">
                <div className="col-lg-6 px-0 position-relative">
                  <div className="col-lg-12  pb-4 pb-md-3">
                    <img
                      src="/mg-full/Skill&intergraton.png"
                      alt="skill"
                      width={"100%"}
                      className="img_round"
                    />
                    {lang ? (
                      <h5 className="position-absolute   section__6__h5">
                        Habilidades e <br /> Integraciones.
                      </h5>
                    ) : (
                      <h5 className="position-absolute   section__6__h5">
                        Skills & <br /> Integrations.{" "}
                      </h5>
                    )}
                  </div>
                </div>
                <div ref={ref2} className="col-lg-6 mt-3 mt-lg-0 ">
                  <div className="row h-100 d-flex justify-content-end ">
                    <div className="col-lg-11 px-0">
                      <div className="row h-100 w-100 graph position-relative">
                        {lang ? (
                          <h5 className="position-absolute graph__h5 ">
                            Arquitectura del Proyecto <br />
                            Escalable.
                          </h5>
                        ) : (
                          <h5 className="position-absolute graph__h5 ">
                            Scalable Project <br />
                            Arquitecture.
                          </h5>
                        )}

                        <div className="col d-flex align-items-end justify-content-center">
                          <img
                            src="/mg-full/graph/g1.png"
                            width={0}
                            className={`${inView2 ? "g1" : ""}`}
                            alt="g1"
                          />
                        </div>
                        <div className="col  d-flex align-items-end justify-content-center">
                          <img
                            src="/mg-full/graph/g2.png"
                            className={`${inView2 ? "g1" : ""}`}
                            width={0}
                            alt="g2"
                          />
                        </div>
                        <div className="col  d-flex align-items-end justify-content-center">
                          <img
                            src="/mg-full/graph/g3.png"
                            className={`${inView2 ? "g1" : ""}`}
                            width={0}
                            alt="g3"
                          />
                        </div>
                        <div className="col  d-flex align-items-end justify-content-center">
                          <img
                            src="/mg-full/graph/g4.png"
                            className={`${inView2 ? "g1" : ""}`}
                            width={0}
                            alt="g4"
                          />
                        </div>
                        <div className="col  d-flex align-items-end justify-content-center">
                          <img
                            src="/mg-full/graph/g5.png"
                            className={`${inView2 ? "g1" : ""}`}
                            width={0}
                            alt="g5"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12   section__4__client__margin section__7">
              <div className="row">
                <div className="col-lg-4 px-0 img__responsive d-flex justify-content-center align-items-center text-center">
                  {lang ? (
                    <h3 className=" color__white">
                      Pixel-Perfect
                      <br />
                      Desarrollo.
                    </h3>
                  ) : (
                    <h3 className="color__white">
                      Pixel-Perfect
                      <br /> Development.
                    </h3>
                  )}
                </div>
                <div className="col-lg-8  mt-3 mt-lg-0">
                  <div className="row d-flex justify-content-end   h-100 ">
                    <div className="p-4 col-lg-11 position-relative row_custom   mt-lg-0  mt-md-0  ms-md-0 d-flex align-items-end justify-content-end">
                      {lang ? (
                        <h5 className="position-absolute responsive__h5 pt-2 ">
                          Diseño Responsive
                        </h5>
                      ) : (
                        <h5 className="position-absolute responsive__h5 pt-2 ">
                          Responsive Design
                        </h5>
                      )}
                      <br />
                      <img
                        src="/mg-full/Responsive_design.png"
                        width="90%"
                        className="section__7__img pt-5 "
                        alt="pixel"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12  section__4__client__margin section__8">
              <div className="row">
                <div className="col-lg-6 code ">
                  <h6 className="pt-5 pb-3 py-lg-5 px-3">
                    {lang ? "Código Límpio" : "Clean Code"}
                  </h6>
                  <div className="intro-card-code-wrap">
                    <div>
                      <span className="code-color">&lt;ul&gt;</span>
                    </div>
                    <div className="intro-card-code-indented">
                      <span className="code-color">&lt;li&gt;</span>
                      {lang ? "HTML Semántico." : "Semantic HTML."}
                      <span className="code-color">&lt;/li&gt;</span>
                    </div>
                    <div className="intro-card-code-indented">
                      <span className="code-color">&lt;li&gt;</span>
                      {lang
                        ? "Denominaciones className."
                        : "className naming system"}
                      <span className="code-color">&lt;/li&gt;</span>
                    </div>
                    <div className="intro-card-code-indented">
                      <span className="code-color">&lt;li&gt;</span>
                      {lang
                        ? "Rendimiento Optimizado."
                        : "Optimized for performance."}
                      <span className="code-color">&lt;/li&gt;</span>
                    </div>
                    <div>
                      <span className="code-color">&lt;/ul&gt;</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6  mt-3 mt-lg-0">
                  <div className="row   h-100 position-relative justify-content-end">
                    <div ref={ref} className="col-lg-11 row_custom  ">
                      <h4 className="pt-5 pb-3 py-lg-5 px-3">
                        {lang
                          ? "Duración de mis desarrollos"
                          : "Duration of my developments"}
                      </h4>

                      <div className={`intro ${inView ? "anim" : ""}`}>
                        <div className="introMonth">
                          <div
                            style={{ width: "110%", height: "10px" }}
                            className="introMonthLine "
                          ></div>
                          <div>{lang ? "Meses" : "Months"}</div>
                        </div>
                        <div className="introWeeks">
                          {lang ? "Semanas" : "Weeks"}
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid section__11 mb-0 " id="mywork">
          <div className="row section__4__content d-flex justify-content-center section__4__client__margin  section__9">
            <div className="row px-0  d-flex justify-content-center">
              <div className="col-lg-9">
                <h4>
                  <span className="about-text">
                    {lang ? "Trabajo" : "Work"}
                  </span>
                </h4>
              </div>
              <div className="col-lg-9">
                {lang ? (
                  <h1>
                    Vea algunos de mis
                    <br /> primeros proyectos.
                  </h1>
                ) : (
                  <h1>
                    Check out some <br />
                    of my first projects.
                  </h1>
                )}
              </div>
              <div className="col-lg-12 px-0   section__4__client__margin pb-3">
                <div className="row px-0">
                  <div className="col-lg-6 position-relative workPage">
                    <TiltPhaseSix options={options}>
                      <img
                        src="/mg-full/Work(A)/WorkA.png"
                        className="border__round"
                        width="100%"
                        alt="workA"
                      />
                      <IoAddCircleSharp
                        className="position-absolute AddCircle"
                        onClick={() => setModalA(!modalA)}
                      />
                    </TiltPhaseSix>{" "}
                  </div>
                  <div className="col-lg-6 mt-3 mt-md-3 mt-lg-0 position-relative workPage">
                    <TiltPhaseSix options={options}>
                      <img
                        src="/mg-full/Work(B)/WorkB.png"
                        className="border__round"
                        width="100%"
                        alt="workA"
                      />
                      <IoAddCircleSharp
                        className="position-absolute AddCircle"
                        onClick={() => setModalB(!modalB)}
                      />
                    </TiltPhaseSix>
                  </div>
                  <div className="col-lg-6 mt-3 mt-md-3 mt-lg-3 position-relative workPage">
                    <TiltPhaseSix options={options}>
                      <img
                        src="/mg-full/El_ArcaWork.png"
                        className="border__round"
                        width="100%"
                        alt="workA"
                      />
                      <IoAddCircleSharp
                        className="position-absolute AddCircle"
                        onClick={() => setModalC(!modalC)}
                      />
                    </TiltPhaseSix>
                  </div>
                  <div className="col-lg-6 mt-3 mt-md-3 mt-lg-3 position-relative workPage">
                    <TiltPhaseSix options={options}>
                      <img
                        src="/mg-full/NixieDipWork.png"
                        className="border__round"
                        width="100%"
                        alt="workA"
                      />
                      <IoAddCircleSharp
                        className="position-absolute AddCircle"
                        onClick={() => setModalD(!modalD)}
                      />
                    </TiltPhaseSix>
                  </div>
                </div>
              </div>
              <div className="col-lg-12  pb-3  px-0">
                <div className="row">
                  <Link to="/reason">
                    <div className="col-lg-12 section__9__grad d-flex justify-content-center align-items-center flex-column">
                      <div>
                        {lang ? (
                          <h2>
                            8 razones para trabajar en
                            <br /> su proyecto con Miguel.
                          </h2>
                        ) : (
                          <h2>
                            8 reasons to work on your <br />
                            project with Miguel.
                          </h2>
                        )}
                      </div>
                      <div>
                        <p className="p-0 m-0">
                          {lang ? "Vea las razones >" : "See reasons >"}
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-lg-12   section__4 section__4__client__margin section__10 pb-3 ">
                <div className="row d-flex justify-content-center">
                  <div className="col-lg-10 py-3 text-center">
                    <div>
                      {lang ? (
                        <h2>Preguntas frecuentes</h2>
                      ) : (
                        <h2>Frequently asked questions</h2>
                      )}
                    </div>
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="m-2 ">
                            <ReactCardFlip
                              className=""
                              isFlipped={isFliped[0]}
                              flipDirection="vertical"
                            >
                              <div>
                                <div className="container-fluid">
                                  <div className="row ReactCardFlipFront d-flex align-items-center">
                                    <div className="col-10 col-md-11  question">
                                      {lang
                                        ? "¿Qué servicios ofreces exactamente?"
                                        : "What services do you offer exactly?"}
                                    </div>
                                    <div className="col-1">
                                      <AiOutlinePlus
                                        onClick={() => HanldeCheck(0)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div className="container-fluid">
                                  <div className="row ReactCardFlipBack d-flex align-items-center">
                                    {lang ? (
                                      <div className="col-10 col-md-11">
                                        Mi atención se centra en el desarrollo
                                        de Webflow de sitios web basados en
                                        diseños de pantalla. Además, ofrezco
                                        servicios de consultoría. durante su
                                        fase de diseño.
                                      </div>
                                    ) : (
                                      <div className="col-10 col-md-11">
                                        My focus is on Webflow development of
                                        websites based on screen designs.
                                        Additionally, I offer consulting
                                        services during your design phase.
                                      </div>
                                    )}
                                    <div className="col-1">
                                      <AiOutlineClose
                                        onClick={() => HanldeCheck(0)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ReactCardFlip>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="m-2 ">
                            <ReactCardFlip
                              className=""
                              isFlipped={isFliped[1]}
                              flipDirection="vertical"
                            >
                              <div>
                                <div className="container-fluid">
                                  <div className="row ReactCardFlipFront d-flex align-items-center">
                                    <div className="col-10 col-md-11 question">
                                      {lang
                                        ? "¿Cuánto cuesta un proyecto?"
                                        : " How much does a project cost?"}
                                    </div>
                                    <div className="col-1">
                                      <AiOutlinePlus
                                        onClick={() => HanldeCheck(1)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div className="container-fluid">
                                  <div className="row ReactCardFlipBack d-flex align-items-center">
                                    {lang ? (
                                      <div className="col-10 col-md-11">
                                        La mayoría de mis proyectos oscilan
                                        entre $ 12,000 y $40,000. Mi tarifa
                                        mínima de participación es $10,000.
                                      </div>
                                    ) : (
                                      <div className="col-10 col-md-11">
                                        Most of my projects range between
                                        $12,000 and $40,000. My minimum
                                        engagement fee is $10,000.
                                      </div>
                                    )}
                                    <div className="col-1">
                                      <AiOutlineClose
                                        onClick={() => HanldeCheck(1)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ReactCardFlip>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="m-2 ">
                            <ReactCardFlip
                              className=""
                              isFlipped={isFliped[2]}
                              flipDirection="vertical"
                            >
                              <div>
                                <div className="container-fluid">
                                  <div className="row ReactCardFlipFront d-flex align-items-center">
                                    <div className="col-10 col-md-11 question">
                                      {lang
                                        ? "¿Con qué empresas trabajas?"
                                        : " Which companies do you work with?"}
                                    </div>
                                    <div className="col-1">
                                      <AiOutlinePlus
                                        onClick={() => HanldeCheck(2)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div className="container-fluid">
                                  <div className="row ReactCardFlipBack d-flex align-items-center">
                                    {lang ? (
                                      <div className="col-10 col-md-11 ">
                                        Principalmente trabajo con tecnología
                                        impulsada empresas, desde nuevas
                                        empresas hasta Fortune 500.
                                      </div>
                                    ) : (
                                      <div className="col-10 col-md-11">
                                        I primarily work with technology driven
                                        companies — from startups to Fortune
                                        500.
                                      </div>
                                    )}
                                    <div className="col-1">
                                      <AiOutlineClose
                                        onClick={() => HanldeCheck(2)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ReactCardFlip>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="m-2 ">
                            <ReactCardFlip
                              className=""
                              isFlipped={isFliped[3]}
                              flipDirection="vertical"
                            >
                              <div>
                                <div className="container-fluid">
                                  <div className="row ReactCardFlipFront d-flex align-items-center">
                                    <div className="col-10 col-md-11 question ">
                                      {lang
                                        ? "¿Trabajas internacionalmente?"
                                        : "Do you work internationally?"}
                                    </div>
                                    <div className="col-1">
                                      <AiOutlinePlus
                                        onClick={() => HanldeCheck(3)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div className="container-fluid">
                                  <div className="row  ReactCardFlipBack d-flex align-items-center">
                                    {lang ? (
                                      <div className="col-10 col-md-11">
                                        Sí. Vivo en España y tengo clientes. en
                                        los EE. UU., Canadá, Inglaterra,
                                        Australia, Nueva Zelanda, Italia,
                                        Francia y Suiza.
                                      </div>
                                    ) : (
                                      <div className="col-10 col-md-11">
                                        Yes. I'm based in Spain and have clients
                                        in the US, Canada, England, Australia,
                                        New Zealand, Italy, France and
                                        Switzerland.
                                      </div>
                                    )}
                                    <div className="col-1">
                                      <AiOutlineClose
                                        onClick={() => HanldeCheck(3)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ReactCardFlip>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="m-2 ">
                            <ReactCardFlip
                              className=""
                              isFlipped={isFliped[4]}
                              flipDirection="vertical"
                            >
                              <div>
                                <div className="container-fluid">
                                  <div className="row ReactCardFlipFront d-flex align-items-center">
                                    <div className="col-10 col-md-11 question">
                                      {lang
                                        ? "¿Cuáles son las condiciones de pago de un proyecto?"
                                        : "   What are the payment terms for a project?"}
                                    </div>
                                    <div className="col-1">
                                      <AiOutlinePlus
                                        onClick={() => HanldeCheck(4)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div className="container-fluid">
                                  <div className="row  ReactCardFlipBack d-flex align-items-center">
                                    {lang ? (
                                      <div className="col-10 col-md-11">
                                        50% por adelantado y 50% después del
                                        lanzamiento. Sin embargo, este
                                        calendario de pagos se puede ajustar.
                                        Para transferencias internacionales, la
                                        mayoría de mis clientes Usa Sabio.
                                      </div>
                                    ) : (
                                      <div className="col-10 col-md-11">
                                        50% upfront and 50% after launch.
                                        However, this payment schedule can be
                                        adjusted. For international transfers,
                                        most of my clients use Wise.
                                      </div>
                                    )}
                                    <div className="col-1">
                                      <AiOutlineClose
                                        onClick={() => HanldeCheck(4)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ReactCardFlip>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="m-2 ">
                            <ReactCardFlip
                              className=""
                              isFlipped={isFliped[5]}
                              flipDirection="vertical"
                            >
                              <div>
                                <div className="container-fluid">
                                  <div className="row ReactCardFlipFront d-flex align-items-center">
                                    <div className="col-10 col-md-11 question">
                                      {lang
                                        ? "¿Cuánto tiempo toma un proyecto?"
                                        : "How long does a project take?"}
                                    </div>
                                    <div className="col-1">
                                      <AiOutlinePlus
                                        onClick={() => HanldeCheck(5)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div className="container-fluid">
                                  <div className="row ReactCardFlipBack d-flex align-items-center">
                                    {lang ? (
                                      <div className="col-10 col-md-11 ">
                                        La mayoría de mis proyectos toman entre
                                        2 semanas y 2 meses.
                                      </div>
                                    ) : (
                                      <div className="col-10 col-md-11 ">
                                        Most of my projects take between 2 weeks
                                        and 2 months.
                                      </div>
                                    )}
                                    <div className="col-1">
                                      <AiOutlineClose
                                        onClick={() => HanldeCheck(5)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ReactCardFlip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid section__2 ">
          <div className="row d-flex justify-content-center">
            <div className="col-9 text-center">
              {lang ? (
                <h1>
                  ¡Hagamos <br /> algo Grande!
                </h1>
              ) : (
                <h1>
                  Let's make <br /> something great
                </h1>
              )}
              <h4 className="bold blue__color text-center pt-5">
                <span onClick={() => setModal(!modal)}>
                  {lang ? "Contactame >" : "Contact me >"}{" "}
                </span>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
